package fyi.moko.hotpl.ui.map

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import fyi.moko.hotpl.domain.model.GeoPoint

/**
 * JS/web actual: a Google map with a single draggable pin. Tapping the map or dragging
 * the pin reports the coordinate via [onPick] (the shared picker contract).
 */
@Composable
actual fun LocationPickerMap(
    latitude: Double?,
    longitude: Double?,
    onPick: (Double, Double) -> Unit,
    userTarget: GeoPoint?,
    myLocationEnabled: Boolean,
    modifier: Modifier,
) {
    val controller = rememberWebMapController(interactive = true, styled = false)
    val currentOnPick by rememberUpdatedState(onPick)

    // Initial camera + tap-to-pick, wired once the map is ready.
    LaunchedEffect(controller.ready) {
        if (!controller.ready) return@LaunchedEffect
        val lat = latitude ?: userTarget?.latitude ?: MapDefaults.FALLBACK_TARGET.latitude
        val lng = longitude ?: userTarget?.longitude ?: MapDefaults.FALLBACK_TARGET.longitude
        controller.centerOn(lat, lng, MapDefaults.DEFAULT_ZOOM.toInt())
        controller.onMapClick { la, ln -> currentOnPick(la, ln) }
    }

    // Keep the pin in sync with the current selection.
    LaunchedEffect(controller.ready, latitude, longitude) {
        if (controller.ready) controller.setPickMarker(latitude, longitude) { la, ln -> currentOnPick(la, ln) }
    }

    WebMapBox(controller, modifier)
}
